import React from 'react';

import MembershipPresenter from '../../../../../../presenters/FastCash/MembershipPresenter';
import Row from '../../../../../../components/Row';
import Value from '../../../../../../components/Value';

const MembershipInfo = (props) => {
  const { membership } = props;

  return (
    <Row className="membership-info">
      <Value attr="state" title="State">
        {MembershipPresenter.stateReadable(membership)}
      </Value>
      <Value attr="createdAt" title="Created at">
        {MembershipPresenter.createdAtReadable(membership)}
      </Value>
      <Value attr="expiresAt" title="Expires at">
        {MembershipPresenter.expiresAt(membership)}
      </Value>
    </Row>
  );
};

export default MembershipInfo;

MembershipInfo.propTypes = {
  membership: MembershipPresenter.shape().isRequired,
};
